module.exports = __webpack_public_path__ + "img/ipad.92f6f138.png";